import { render, staticRenderFns } from "./AddFilterOutRule.vue?vue&type=template&id=38731226&scoped=true"
import script from "./AddFilterOutRule.vue?vue&type=script&lang=js"
export * from "./AddFilterOutRule.vue?vue&type=script&lang=js"
import style0 from "./AddFilterOutRule.vue?vue&type=style&index=0&id=38731226&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38731226",
  null
  
)

export default component.exports